import { render, staticRenderFns } from "./AgendadasHoje.vue?vue&type=template&id=48dc949e"
import script from "./AgendadasHoje.vue?vue&type=script&lang=js"
export * from "./AgendadasHoje.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports